<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card class="visitor-details-panel">
    <b-card-title>Visitor Details</b-card-title>

    <section v-if="!loading && visitor">
      <b-alert variant="warning" class="p-1" v-if="visitor.offsite_id && !visitor.email.includes('intake-visit')" show>Please note this is an inter-prison visitor</b-alert>
      <b-alert variant="warning" class="p-1" v-if="visitor.offsite_id && visitor.email.includes('intake-visit')" show>Please note: As this in a PV on Demand call we only have the visitor info you entered.</b-alert>
      <visitor-images></visitor-images>
      <identity-type :person="visitor"></identity-type>
      <details-basic :person="visitor"></details-basic>
    </section>

    <b-spinner v-else variant="primary" label="Loading..."></b-spinner>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import VisitorImages from '@/components/visitors/details/sections/VisitorImages.vue';
import IdentityType from '@/components/sharedVisitorDetails/IdentityType.vue';
import DetailsBasic from '@/components/sharedVisitorDetails/DetailsBasic.vue';

export default {
  name: 'visitor-details',
  components: {
    VisitorImages,
    IdentityType,
    DetailsBasic,
  },
  props: {
    visitor_user_id: {
      type: String,
      required: true,
    },
  },
  watch: {
    visitor_user_id() {
      // Get visitor info
      this.getVisitor();
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      visitor: state => state.visitor.visitor,
    }),
  },
  data() {
    return {
      loading: true,
      intervalId: '', // for polling
    };
  },
  mounted() {
    this.getVisitor();
    this.pollVisitor();
  },
  beforeDestroy() {
    this.clearPolling();
  },
  methods: {
    pollVisitor() {
      this.intervalId = setInterval(() => {
        this.getVisitor();
      }, 300000); // 5 Mins
    },
    async getVisitor() {
      this.loading = true;

      await this.$store.dispatch('visitor/getVisitor', this.visitor_user_id);

      setTimeout(() => {
        this.loading = false;
      }, 500); // delay so it doesn't flicker
    },
    clearPolling() {
      clearInterval(this.intervalId);
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>
